import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { BehaviorSubject, debounceTime, Subject } from 'rxjs';
import { EventViewModel } from '../../../models-views/event.view.model';
import { OutsourcingRequestVendorModel, OutsourcingRequestVendorResponseModel } from '../../../models/vendor.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { VendorRequestModalComponent } from './vendor-request-modal/vendor-request-modal.component';
import { environment } from '../../../../environments/environment';
import { CetVendorDetailsComponent } from '../cet-vendor-details/cet-vendor-details.component';

@Component({
  selector: 'app-cet-vendor-requests',
  standalone: false,
  templateUrl: './cet-vendor-requests.component.html',
  styleUrl: './cet-vendor-requests.component.scss'
})
export class CetVendorRequestsComponent {

  @Input('eventId') eventId: string | null = null;
  outsourcingRequestVendorList: OutsourcingRequestVendorModel[] = [];
  outsourcingRequestVendorModel = new BehaviorSubject<OutsourcingRequestVendorResponseModel>(
    new OutsourcingRequestVendorResponseModel()
  );
  loading: boolean = false;
  searchValue: string = '';
  searchValue$ = new Subject();
  pageIndex = 1;
  pageSize = 30;
  sampleFallbackImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEf0lEQVR4nO3ZS08bVxgG4GmVqlJUVaqo1G6qSpXabsJlZvBljmdsIlVVNl100UU3XXVfcmkAE2JIgnMBZmxsDzgXIvUHZEOatlEaG0gUAi2BVoBSRN2onjEGgw2lCQSHrzrjEOwJpjaML0h+pVfCu3l0znfOGBNEKaWUUvBIXno/LrGXE+RNn0k8CsgCCsqC8SsA4hViL0XijZQsMP2ygCC5koDuz3SYjESxJ+jSlck8cko8E1cjXmB4tC4J6LvwBd27RLEFvPRrEs98Iwkolg7w8uowy5LANP/hPPQ6UQwJ8sZPJJ4ZzxSwRadCDuaLwgEE9LHEM9/vApBaHt0KOZgDeQM8Etm3ZB6dkwW0qhlic7utyQLySu2Wt3MGABvxKj5CJQGFtQZs0Xk8c2Cz7NMUEepAB2UejeUBAKpOyh3GQ7sGBNu59/BRWQAApGw5HvXO8OwHWQPCbssbMs/YZYF5UmiELCD4u4OB4SZqLWtIzMNGC/3wMi6PYPyMHn46Vgm9teWQNQSu1sDTyxaIdJoKhpg6Z4Db9VUKYKM7gmz0yUUzhJ35Az1qZ+BuIwW9hzcBuD8erYhnDVnv2YTgrvdYYEnkIOTIHUASEIye0sGNwxUpgOu15dBXRw7daz3wTtaQf0WTceWi+a9kDG68xwJRD6c5YtKuh5vfJuYgub76KuhvoLLfUur808XB2mVLCgZ39ZIZ5jSYn+nzBvDXpc5Bb2053DxWCXcaKQWCu2vIUhcHuMvdZnjWowZZ4LHXDDMO046O0/snabiumoMbRypgwEqCvyEB0ByitJtTHjyunp+rNYBXLpTJHPDP5+BI6hzgwe63ktDXQKYAcgN53h+OVih7Wr3d1q5YYMHNpkU8PGuAW1vMwe26Khiwbm4jX/4g5XCnkYRJu05ZCTVo5ZIZZpOO60CbUdkuL89BYhttB/DlEoLP+ZGWavilmYZfm2kIXDAol6cahOdqqCnNHDRS4E+zjXz5guBGRRamzhsUCAY9aKlW5keNUd8H/vr0c+ArBGSjEbcJJux6BZM4EFjlaFZDfj6O5yB7gC9fkI3iWzn583I3B/ErFvxakQCojtOihSxt0UWRA3995a4AvmKA4GqB8JUgSSmtSJd2W8vfQOZnRhY8LATaDDmZkcEmauZ3m6Fm15CIy1QbE7nH20Eenk3cIxGXKXFaaQAZsJKrD07RjYSWARuxb8GNvDGRe5YOM9Gqh+k2I4Q7EYy36pVvkzuB9DWQ68M2+lpO/7Ettx18f8HN3sP3gxqCV2RRZOHPNqPy2hJyJlYn4zmor4Khk/TEhI39iMhXIk7u06iHDaesiF3/4u+x09UQaGcyhgyeIOd/O0N9ThQq853oeFRkV7ZanUxmZMBa9XSkpZoniiHgpffPudlriyK7vvmab9wWgr/GDtso/6BN/yZRbJl1mD+MutnR/zt+B5vI6dHW6vz9BrLTzHayX8bcbEwNuXuCWh6z6b4m9lrmXOzpmIddG7CS8ZFm2ot/WyH2ahZdurIJu66s0M9RSimlEMR/TIEr5XGyxMUAAAAASUVORK5CYII="
  constructor(private vm: EventViewModel, private route: ActivatedRoute, private modalService: NzModalService,
    private message: NzMessageService
  ) {
    this.searchValue$.pipe(debounceTime(500)).subscribe(name => {
      this.pageIndex = 1;
      this.getData();
    });
  }

  ngOnInit(): void {
    this.vm.parentCetVendorRequestsComponent = this;
    this.vm.subscribeToRFQ(this.outsourcingRequestVendorModel);
  }

  getData() {
    this.loading = true
    this.vm.getOutsourcingRequestVendor(1, 100, this.eventId, this.searchValue)
  }

  outsourcingRequestVendorRecieved() {
    this.outsourcingRequestVendorList = this.outsourcingRequestVendorModel.value.results;
    this.loading = false
  }

  rfqRef?: NzModalRef;
  onAdd() {
    this.rfqRef = this.modalService.create({
      nzTitle: 'Request for quotation',
      nzContent: VendorRequestModalComponent,
      nzFooter: null,
      nzStyle: {
         top: '50px',
      },
      nzData: {
        eventId: this.eventId
      }
    });

    this.rfqRef.afterClose.subscribe(result => {
      if (result === true) {
        this.getData();
      }
    });

  }

  onEdit(data:any) {
    console.log(data)
    this.rfqRef = this.modalService.create({
      nzTitle: 'Edit Request for quotation',
      nzContent: VendorRequestModalComponent,
      nzFooter: null,
      nzStyle: {
         top: '50px',
      },
      nzData: {
        eventData: data,
        eventId: this.eventId
      }
    });

    this.rfqRef.afterClose.subscribe(result => {
      if (result === true) {
        this.getData();
      }
    });

  }

  onVendorDetails(id:number) {
    this.rfqRef = this.modalService.create({
      nzTitle: 'Vendor Details',
      nzContent: CetVendorDetailsComponent,
      nzFooter: null,
      nzWidth:'90vw',
      nzStyle: {
         padding: '40px',
      },
      nzData: {
        id: id
      }
    });

    this.rfqRef.afterClose.subscribe(result => {
      if (result === true) {
        this.getData();
      }
    });

  }

  deleteRequest(id: string){
    this.vm.deleteVendorRequest(id);
  }

  requestDeleted() {
    this.getData();
  }

  getOursouringTypeImage(item: any) {
    const image = item?.quotation_request_details?.outsourcing_event_request_details?.outsourcing_type_details?.image;
    return image ? image : ''
  }

   getStatusBadge(status: string): string {
    switch (status) {
      case 'VIEWED': return 'success';
      case 'PENDING': return 'processing';
      case 'DRAFTING': return 'default';
      case 'SUBMITTED': return 'warning';
      case 'DECLINED': return 'danger';
      default: return 'default';
    }
  }

  onSearch() {
    this.searchValue$.next(this.searchValue);
  }


  copyLink(item: any): void {
    const link = `${environment.app_url}/external/outsourcing?requestId=${item.quotation_request_vendor_id}&accessToken=${item.access_token}`;
    navigator.clipboard.writeText(link).then(() => {
      this.message.success('Link copied to clipboard!');
    });
  }

}
